'use client';

import { UiProvider as Provider } from '@jouzen/ecom-components/layout';
import { CurrencyProvider } from '@jouzen/ecom-components/v3/Price';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import type { PropsWithChildren } from 'react';

import useCurrency from '../hooks/useCurrency';

interface UiProviderProps {
  readonly locale: string;
}

function UiProvider({ children, locale }: PropsWithChildren<UiProviderProps>) {
  const { countryData, currencyCode } = useCurrency();
  const t = useTranslations();

  const currencyProps = {
    country: countryData?.countryCode ?? 'US',
    fallbackCurrencyCode: currencyCode,
    fallbackLocale: locale,
    freeMessage: t('cart_free'),
    locale,
  };
  return (
    <Provider
      // @ts-expect-error --Fix type error
      ImageComponent={Image}
      LinkComponent={Link}
      currencyProps={currencyProps}
      intlProps={{ locale }}
    >
      <CurrencyProvider {...currencyProps}>{children}</CurrencyProvider>
    </Provider>
  );
}

export default UiProvider;
